module.exports = __webpack_public_path__ + "media/images/ic-block-aa657c5ffe3024dfb91c32ba9f70f4cc.svg";